// extracted by mini-css-extract-plugin
export default {"aboutContainer":"About_aboutContainer__8+5vB","aboutWrapper":"About_aboutWrapper__mbTaH","aboutColLeft":"About_aboutColLeft__nKHpR","aboutColRight":"About_aboutColRight__ZX2Tu"};